import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueSwal from 'vue-swal'
import VueMoment from 'vue-moment'
import moment from 'moment'
require('moment/locale/es')
import VueCookies from 'vue-cookies'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueGtag from "vue-gtag"
import * as VueGoogleMaps from 'vue2-google-maps'
import VueFacebookPixel from 'vue-facebook-pixel'
import { normalizePublicBusinessSlug } from './utils/publicGateway'
// import VueShepherd from 'vue-shepherd';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// routes
//import Home from './pages/Home'
//import Product from './pages/Product'
const Product = () => import(/* webpackChunkName: "product" */ './pages/Product')
//import Products from './pages/Products'
const Products = () => import(/* webpackChunkName: "products" */ './pages/Products')
//import ViewProduct from './pages/ViewProduct'
const ViewProduct = () => import(/* webpackChunkName: "viewproduct" */ './pages/ViewProduct')
//import Cart from './pages/Cart'
//import Ticket from './pages/Ticket'
const Ticket = () => import(/* webpackChunkName: "ticket" */ './pages/Ticket')
//import Zones from './pages/Zones'
//import Page from './pages/Page'
const Page = () => import(/* webpackChunkName: "page" */ './pages/Page')
//import Account from './pages/Account'
const Account = () => import(/* webpackChunkName: "account" */ './pages/Account')
const Login = () => import(/* webpackChunkName: "login" */ './pages/Login')
const Register = () => import(/* webpackChunkName: "register" */ './pages/Register')
//import NotFound from './pages/NotFound'
const NotFound = () => import(/* webpackChunkName: "notfound" */ './pages/NotFound')
//import Tos from './pages/Tos'
const Tos = () => import(/* webpackChunkName: "tos" */ './pages/Tos')
// payment
const Payment = () => import(/* webpackChunkName: "payment" */ './pages/Payment')

Vue.config.productionTip = false

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBkuOFrbSMDAEKbpD8oD7_-uSUlUZ_IrBM',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})


Vue.use(
  VueGtag, {
  config: {
    id: "G-VNQQ0NFVXW"
  }
})

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueSwal)
Vue.use(VueMoment, {
  moment
})
Vue.use(VueCookies)
Vue.use(VueFacebookPixel)
// Vue.use(VueShepherd);

Vue.$cookies.config('3y')
Vue.prototype.$bus = new Vue()

/* eslint-disable-next-line */
if (process.env.NODE_ENV === 'production' || true) {
  Vue.http.options.root = 'https://webapi.ticketapp.cl'
}
else {
  Vue.http.options.root = 'http://192.168.1.2:3000/w/'
}
// Vue.http.options.root = 'https://dev.rowen.ticketapp.cl/'
//Vue.http.options.root = 'http://localhost:3000/w/'
//Vue.http.options.root = 'http://192.168.1.2:3001/w/'


const routes = [
  {
    path: '/',
    component: Page,
    name: 'Home'
  },
  { path: '/cuenta', component: Account },
  { path: '/ingresar', component: Login },
  { path: '/registro', component: Register },
  // {
  //   path: '/menu',
  //   component: Home,
  //   name: 'menuDomain'
  // },
  { path: '/tos', component: Tos },
  { path: '/productos/categoria/:cname/:cid', component: Products },
  { path: '/productos/:id', component: ViewProduct },
  { path: '/productos/:id/:name', component: ViewProduct },
  { path: '/pago/:id', component: Payment },
  {
    path: '/productos',
    component: Products,
    name: 'productsDomain'
  },
  //{ path: '/delivery', component: Zones },
  //{ path: '/pedido', component: Cart },
  { path: '/pedido/:id', component: Ticket },
  // without domain
  { path: '/:name', component: Page },
  { path: '/:name/tos', component: Tos },
  { path: '/:name/ingresar', component: Login },
  { path: '/:name/registro', component: Register },
  // {
  //   path: '/:name/menu',
  //   component: Home,
  //   name: 'menu'
  // },
  { path: '/:name/cuenta', component: Account },
  { path: '/:name/p/:pid', component: Product },
  //{ path: '/:name/delivery', component: Zones },
  //{ path: '/:name/pedido', component: Cart },
  { path: '/:name/productos', component: Products },
  { path: '/:name/productos/categoria/:cname/:cid', component: Products },
  { path: '/:name/productos/:id', component: ViewProduct },
  { path: '/:name/productos/:id/:pname', component: ViewProduct },
  { path: '/:name/:id', component: Page },
  { path: '/:name/pedido/:id', component: Ticket },
  { path: '/:name/pago/:id', component: Payment },
  { path: '/:name/404', component: NotFound },
  { path: '/404', component: NotFound },
  { path: '/*', component: NotFound }
]

const store = new Vuex.Store({
  state: {
    lastSeen: '',
    products: [],
    cartDraft: {},
    productDrafts: {},
    editingCartProduct: null,
    cartLoadedBusinessId: null,
    categories: [],
    store: null,
    product: {},
    info: {
      settings: {},
      pages: []
    },
    page: {},
    isDomain: false,
    PVK: 'BKeuomlJ2-aTyyQee4oESXWWR71Au8um2o2M9nyAoV9a15ovfCo5tKkAUFp0dGTVu_p8_c2kDtfb7AXgDJfv1M8',
    lastscroll: null,
    token: '',
    components: []
  },
  mutations: {
    setLastseen(state, data) {
      state.lastSeen = data
    },
    setComponents(state, components) {
      state.components = components
    },
    addProduct(state, product) {
      state.products.push(product)
      // Vue.$cookies.set('products', state.products)
    },
    replaceProductByTempid(state, product) {
      if (!product || !product.tempid) {
        state.products.push(product)
        return
      }

      const index = state.products.findIndex((item) => item.tempid === product.tempid)
      if (index === -1) {
        state.products.push(product)
        return
      }

      state.products.splice(index, 1, product)
    },
    setProduct(state, product) {
      state.product = product
    },
    setProducts(state, products) {
      state.products = products
      // Vue.$cookies.set('products', products)
    },
    clearProducts(state) {
      state.products = []
    },
    setCartDraft(state, draft) {
      state.cartDraft = {
        ...state.cartDraft,
        ...(draft || {})
      }
    },
    replaceCartDraft(state, draft) {
      state.cartDraft = draft || {}
    },
    setProductDraft(state, { productId, draft }) {
      if (!productId) return
      state.productDrafts = {
        ...state.productDrafts,
        [productId]: draft || {}
      }
    },
    clearProductDraft(state, productId) {
      if (!productId) return
      const drafts = { ...state.productDrafts }
      delete drafts[productId]
      state.productDrafts = drafts
    },
    setEditingCartProduct(state, payload) {
      state.editingCartProduct = payload || null
    },
    clearEditingCartProduct(state) {
      state.editingCartProduct = null
    },
    setCartLoadedBusiness(state, businessId) {
      state.cartLoadedBusinessId = businessId || null
    },
    setInfo(state, info) {
      state.info = info
    },
    setPage(state, page) {
      state.page = page
    },
    setDomainTrue(state) {
      state.isDomain = true
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    setLastscroll(state, date) {
      state.lastscroll = date
    },
    setToken(state, token) {
      state.token = token
    }
  }
})

const router = new VueRouter({
  routes,
  mode: 'history'
})

Vue.filter('formatNumber', (num = 0) => {
  if (!num) return 0

  if (num.toString().indexOf('.') != -1) {
    let decimal = num.toString()[num.toString().indexOf('.') + 1]
    if (decimal > 5) num = num + 1
  }
  let result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  if (result.indexOf('.') > -1)
    result = result.substring(0, result.indexOf('.'))
  return result
})

const CART_SESSION_COOKIE = 'cartSessionKey'
let remoteCartSyncTimeout = null

const getEmptyCartDraft = () => ({
  tip: 0,
  rut: '',
  commune: '',
  time: -1,
  date: -1,
  type: '',
  payment: '',
  amount: 0,
  clientName: '',
  phone: '',
  email: '',
  notes: '',
  address: '',
  zone: {},
  center: {
    lat: 0,
    lng: 0,
  },
  couponCode: '',
  coupon: {},
  cuponDisabled: false,
})

const ensureCartSessionKey = () => {
  let sessionKey = Vue.$cookies.get(CART_SESSION_COOKIE)
  if (sessionKey) return sessionKey

  sessionKey = `cart_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`
  Vue.$cookies.set(CART_SESSION_COOKIE, sessionKey)
  return sessionKey
}


const analyticsEventMemory = new Map()

const getAnalyticsBusinessSlug = (route = null) => {
  const domain = window.location.host.replace(':', '')
  const currentRoute = route || router.currentRoute || {}

  if (store.state.isDomain) return domain

  return (
    (currentRoute.params && currentRoute.params.name) ||
    (store.state.info && store.state.info.webName) ||
    ''
  )
}

const getAnalyticsUtmParams = () => {
  const params = new URLSearchParams(window.location.search || '')
  return {
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
  }
}

const trackWebSessionEvent = ({ eventType, path = '', referer = '', pageTitle = '', route = null, force = false, delayMs = 0 } = {}) => {
  const sessionKey = ensureCartSessionKey()
  const businessSlug = getAnalyticsBusinessSlug(route)
  if (!sessionKey || !businessSlug) return Promise.resolve(null)

  const normalizedPath = path || `${window.location.pathname}${window.location.search}`
  const dedupeKey = `${businessSlug}|${sessionKey}|${eventType}|${normalizedPath}`
  const now = Date.now()

  if (!force && analyticsEventMemory.has(dedupeKey) && now - analyticsEventMemory.get(dedupeKey) < 3000) {
    return Promise.resolve(null)
  }

  analyticsEventMemory.set(dedupeKey, now)

  const send = () => {
    const payload = {
      sessionKey,
      cartSessionKey: sessionKey,
      eventType,
      path: normalizedPath,
      pageTitle: pageTitle || document.title || '',
      referer: referer || document.referrer || '',
      ...getAnalyticsUtmParams(),
    }

    return Vue.http.post(`${businessSlug}/analytics/session`, payload).catch((error) => {
      console.log('web analytics session error', error)
      return null
    })
  }

  if (delayMs > 0) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(send())
      }, delayMs)
    })
  }

  return send()
}

const getCartHeaders = () => {
  const headers = {
    cartsessionkey: ensureCartSessionKey(),
  }

  const token = Vue.$cookies.get('token')
  if (token) headers.token = token
  return headers
}

const buildRemoteCartPayload = (state) => {
  const draft = state.cartDraft || {}
  return {
    bid: state.info && state.info._id ? state.info._id : '',
    clientName: draft.clientName || '',
    rut: draft.rut || '',
    phone: draft.phone || '',
    email: draft.email || '',
    type: draft.type || '',
    address: draft.address
      ? `${draft.address}${draft.commune ? ` ${draft.commune}` : ''}`.trim()
      : '',
    gps: draft.center || { lat: 0, lng: 0 },
    payment: draft.payment
      ? (draft.payment.name || draft.payment)
      : '',
    amount: draft.amount || 0,
    deliveryValue: Number(draft.deliveryValue) || 0,
    coupon: draft.coupon || {},
    date: draft.date !== undefined ? draft.date : -1,
    time: draft.time !== undefined ? draft.time : -1,
    tip: draft.tip || 0,
    notes: draft.notes || '',
    products: state.products || [],
  }
}

const getRemoteCartDraft = (cart = {}) => ({
  ...getEmptyCartDraft(),
  clientName: cart.clientName || '',
  rut: cart.rut || '',
  phone: cart.phone || '',
  email: cart.email || '',
  type: cart.type || '',
  address: cart.address || '',
  payment: cart.payment || '',
  amount: cart.amount || 0,
  deliveryValue: cart.deliveryValue || 0,
  coupon: cart.coupon || {},
  couponCode: cart.coupon && cart.coupon.code ? cart.coupon.code : '',
  cuponDisabled: !!(cart.coupon && cart.coupon._id),
  date: cart.date !== undefined ? cart.date : -1,
  time: cart.time !== undefined ? cart.time : -1,
  tip: cart.tip || 0,
  notes: cart.notes || '',
  center: cart.gps || { lat: 0, lng: 0 },
})

const normalizeRemoteCartProducts = (products = []) =>
  (products || []).map((product, index) => ({
    ...product,
    tempid:
      product && product.tempid
        ? product.tempid
        : product && product._id
          ? product._id
          : `remote-${Date.now()}-${index}`,
  }))

const syncRemoteCart = () => {
  const state = store.state
  if (!state.info || !state.info._id) return Promise.resolve(null)
  if (state.cartLoadedBusinessId !== state.info._id) return Promise.resolve(null)

  return Vue.http.post('cart', buildRemoteCartPayload(state), {
    headers: getCartHeaders(),
  }).catch((error) => {
    console.log('remote cart sync error', error)
    return null
  })
}

const scheduleRemoteCartSync = () => {
  clearTimeout(remoteCartSyncTimeout)
  remoteCartSyncTimeout = setTimeout(() => {
    syncRemoteCart()
  }, 500)
}

store.subscribe((mutation, state) => {
  const syncMutations = [
    'addProduct',
    'setProducts',
    'clearProducts',
    'setCartDraft',
    'replaceCartDraft',
  ]

  if (mutation.type === 'setInfo' && state.info && state.info._id && state.cartLoadedBusinessId !== state.info._id) {
    store.commit('setCartLoadedBusiness', null)
  }

  if (syncMutations.includes(mutation.type)) {
    scheduleRemoteCartSync()
  }
})

Vue.mixin({
  methods: {
    ensureCartSessionKey() {
      return ensureCartSessionKey()
    },
    getCartHeaders() {
      return getCartHeaders()
    },
    syncRemoteCart() {
      return syncRemoteCart()
    },

    trackWebSessionEvent(payload = {}) {
      return trackWebSessionEvent(payload)
    },
    trackPageview(route = null) {
      return trackWebSessionEvent({
        eventType: 'pageview',
        route,
        path: `${window.location.pathname}${window.location.search}`,
        referer: document.referrer || '',
        delayMs: 1000,
      })
    },
    trackCheckoutStart(path = '/checkout') {
      return trackWebSessionEvent({
        eventType: 'checkout_start',
        path,
        delayMs: 1000,
      })
    },

    safeFbq(action, eventName, payload = {}) {
      try {
        const analytics = this.$analytics
        if (!analytics) return false

        if (typeof analytics.fbq === 'function') {
          analytics.fbq(action, eventName, payload)
          return true
        }

        if (analytics.fbq && typeof analytics.fbq.call === 'function') {
          analytics.fbq.call(analytics, action, eventName, payload)
          return true
        }

        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
          window.fbq(action, eventName, payload)
          return true
        }
      } catch (error) {
        console.log('facebook pixel error', error)
      }

      return false
    },
    async loadRemoteCart({ force = false } = {}) {
      const businessId = this.$store.state.info && this.$store.state.info._id
      if (!businessId) return null
      if (!force && this.$store.state.cartLoadedBusinessId === businessId) return null

      try {
        const res = await this.$http.get(`cart?bid=${businessId}`, {
          headers: this.getCartHeaders(),
        })
        const cart = res.data.data
        this.$store.commit(
          'setProducts',
          cart && cart.products ? normalizeRemoteCartProducts(cart.products) : []
        )
        this.$store.commit('replaceCartDraft', cart ? getRemoteCartDraft(cart) : getEmptyCartDraft())
        this.$store.commit('setCartLoadedBusiness', businessId)
        return cart
      } catch (error) {
        console.log('remote cart load error', error)
        this.$store.commit('replaceCartDraft', getEmptyCartDraft())
        this.$store.commit('setCartLoadedBusiness', businessId)
        return null
      }
    },
    getPromo(promo, value, short = false) {
      let rs = ''
      if (!promo.enabled) return;
      if (promo.to == "product")
        rs +=
          `$${value - promo.discount} sobre ${promo.value} un.` +
          " \n";
      if (promo.to == "total") {
        if (promo.in == "$" && promo.when == "total")
          rs += `${promo.discount} dcto sobre $${promo.value}` + " \n";
        if (promo.in == "$" && promo.when == "qty")
          rs += `-$${promo.discount} dcto desde ${promo.value} un.` + " \n";
        if (promo.in == "%" && promo.when == "qty")
          rs += `${promo.discount}% dcto desde ${promo.value} un.` + " \n";
        if (promo.in == '%' && promo.when == 'total')
          rs += `${promo.discount}% dcto sobre $${promo.value}` + " \n";
      }
      if (promo.to == "option")
        rs += (
          promo.when == 'minopcion' && promo.value
            ? `${promo.in == "$" ? "-$" : ""}${promo.discount}${promo.in == "%" ? "%" : ""} en extras desde $${promo.value}`
            : `${promo.in == "$" ? "-$" : ""}${promo.discount}${promo.in == "%" ? "%" : ""} en opciones extra`
        ) + " \n";
      //console.log({ promo });

      if (short) {
        //return rs.split('dcto')[0]
        return 'Oferta'
      }
      if (rs == undefined) return ''
      return rs;
    },
    calificationAvailable(ticket) {
      let { createdAt } = ticket;
      let now = this.$moment();
      let diff = now.diff(createdAt, "weeks");
      let diffHours = now.diff(createdAt, "hours");
      console.log('hours', diffHours)
      return !ticket.rating && diff < 8 && ticket.status == "Aceptado" && diffHours > 1;
    },
    checkCondition(current, con, value) {
      if (con == "lt") return current < value;
      if (con == "lte") return current <= value;
      if (con == "eq") return current == value;
      if (con == "gt") return current > value;
      if (con == "gte") return current >= value;
    },
    isLogged() {
      let token = Vue.$cookies.get('token')
      return token && token != ''
    },
    getBgCustomMessage() {
      let css = "";
      let { settings } = store.state.info
      if (!settings) return css
      // if bg is white add text-dark
      if (settings.bgCustomMessage == "white") css += "text-dark ";
      css += `bg-${settings.bgCustomMessage}`;
      return css;
    },
    getTheme() {
      let { settings } = store.state.info
      if (!settings) return ''
      return {
        "bg-dark text-white": settings.headerColor == "dark",
        "bg-light text-dark": settings.headerColor == "light",
      };
    },
    getThemeFooter() {
      let { settings } = store.state.info
      if (!settings) return ''
      return {
        "bg-dark text-white": settings.footerColor == "dark",
        "bg-light text-dark": settings.footerColor == "light",
      };
    },
    getThemeText() {
      let { settings } = store.state.info
      if (!settings) return { 'text-white': 1 }

      return {
        "text-white": settings.headerColor == "dark",
        "text-dark": settings.headerColor == "light",
      };
    },
    getThemeBody() {
      let { settings } = store.state.info
      if (!settings) return 'no-theme-body'
      if (settings.bodyColor && settings.bodyColor.indexOf("img") == 0) {
        return `bg-${settings.bodyColor}`;
      }
      return {
        "bg-dark text-white": settings.bodyColor == "dark",
        "bg-light text-dark":
          settings.bodyColor == "light" ||
          settings.bodyColor == "white",
      };
    },
    openInMaps(address) {
      address = `${address}`;
      address = address.replace(/#/g, " ");
      window.open(`https://maps.google.com/?q=${address}`, "_blank");
      this.$gtag.event("address_click", {
        event_category: "maps",
        event_label: "View address on maps",
        value: 1,
      });

    },
    getLink(link) {
      if (link == 'cart') link = 'pedido'
      link = `${link || ''}`.trim()

      if (link === '/') {
        return store.state.isDomain ? '/' : `/${normalizePublicBusinessSlug(store.state.info.webName)}/`
      }

      link = link.replace(/^\/+/, '')

      if (store.state.isDomain) {
        return `/${link}`
      }
      return `/${normalizePublicBusinessSlug(store.state.info.webName)}/${link}`
    },
    todayRaw() {
      const info = store.state.info || {};
      const settings = info.settings || {};
      const days = Array.isArray(settings.days) ? settings.days : [];
      const date = Vue.moment();
      if (days.length == 0) return false;
      return days.find(d => d.n == date.format('d')) || false;
    },
    today() {
      const info = store.state.info || {};
      const settings = info.settings || {};
      const days = Array.isArray(settings.days) ? settings.days : [];

      if (days.length == 0) return false

      let date = Vue.moment()
      let currentDay = days.find(d => d.n == date.format('d'))

      if (currentDay) {
        let { openAt, closeAt } = currentDay
        if (!openAt || !closeAt) return false
        let dayName = Vue.moment(openAt, 'HH:mm:ss').format('dddd')
        let open = Vue.moment(openAt, 'HH:mm:ss').format('HH:mm')
        let close = Vue.moment(closeAt, 'HH:mm:ss').format('HH:mm')
        return `${dayName} ${open} - ${close}`
      }
      else return ''

    },
    schedule() {
      const info = store.state.info || {};
      const settings = info.settings || {};
      return Array.isArray(settings.days) ? settings.days : [];

    },
    status() {
      let { info, lastSeen } = store.state
      if (info && info.settings) {
        let { settings } = info
        if (!settings) return 'Offline'

        if (settings.closedUntil) {
          let diff = Vue.moment(settings.closedUntil).diff(Vue.moment(), 'minutes')
          //console.log({ closedUntil: settings.closedUntil, diff })
          if (diff > 0) return 'Offline'
        }
        if (settings.status == 'app') {
          //console.log({lastSeen})
          if (!lastSeen) return 'Offline'

          //console.log(Vue.moment(lastSeen).format('HH:mm:ss'),Vue.moment().diff(lastSeen, 'minutes'))
          if (Vue.moment().diff(lastSeen, 'minutes', true) > 4) {
            return 'Offline'
          }
          return 'Online'
        }
        if (settings.status == 'schedule') {
          let days = settings.days
          let today = Vue.moment().format('d')

          // get current day
          let currentDay = days.find(d => today == d.n)
          // console.log({ currentDay })

          // if day is not found return offline
          if (currentDay && currentDay.openAt && currentDay.closeAt) {
            let hour = Vue.moment()
            let openAt = Vue.moment(currentDay.openAt, 'HH:mm:ss')
            let closeAt = Vue.moment(currentDay.closeAt, 'HH:mm:ss')
            if (currentDay.breakEnabled) {
              console.log('break enabled')
              let breakStart = Vue.moment(currentDay.breakStart, 'HH:mm:ss')
              let breakEnd = Vue.moment(currentDay.breakEnd, 'HH:mm:ss')
              if (hour.isBefore(breakEnd) && hour.isAfter(breakStart)) return 'Offline'
            }
            if (hour.isBefore(closeAt) && hour.isAfter(openAt)) return 'Online'
          }
        }
        if (settings.status == 'always') return 'Online'
      }
      return 'Offline'
    },
    getLogo(path = null) {
      // test
      if (!path || path == undefined || path == '') return ' data:image/jpeg;base64,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'

      return `https://static3.ticketapp.cl/${path}`
    },
    /* eslint-disable-next-line */
    getImage(path = null, size = null) {
      // test
      if (!path || path == undefined || path == '') return ' data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAA0JCgsKCA0LCgsODg0PEyAVExISEyccHhcgLikxMC4pLSwzOko+MzZGNywtQFdBRkxOUlNSMj5aYVpQYEpRUk8BDg4OExETJhUVJk81LTVPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT//AABEIAQABAAMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APTqACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoACQO4oATcPUUAG4eooANw9RQAbh6igA3D1FABuHqKADcPUUAG4eooANw9RQAbh6igA3D1FABuHqKAFBB7igAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCCb79ADKACgAoAKACgAoAKACgAoAKACgAoAfD9+gCegAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAIJvv0AEab880AO8kepoAPJHqaADyR6mgA8kepoAPJHqaADyR6mgA8kepoAPJHqaADyR6mgA8kepoAa8ewZzQAQ/foAnoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCCb79ADoOhoAloAKAAkDqaACgAoAKACgAoAKACgCOb7o+tADIfv0AT0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBBN9+gB0HQ0AS0AIx2qTQBWJJOTQBLCx+6aAJaACgAoAKACgAoAjm+6PrQAyH79AE9ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAQTffoAdB0NAEtADZRlDQBXoAfCPn+lAE9AASAMmgAoAKACgAoAjm+6PrQAyH79AE9ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAQTffoAdB0NAEtABQBEYeeDigB6IFHFADqAIJX3HA6CgB0LcbT+FAEtABQAUARzfdH1oAZD9+gCegAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAIJvv0AOg6GgCWgAoAKACgCOV8DA6mgCGgABwcigB6Od+SetAE9ABQBHN90fWgBkP36AJ6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAgm+/QA6DoaAJaACgAoARmCrk0AVicnJoAKACgAoAsRtuX3FADqAI5vuj60AMh+/QBPQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEE336AHQdDQBLQAjEKMmgCDzG3ZzQAO5c80ANoAKACgAoAdG21vY0AWKAI5vuj60AMh+/QBPQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEE336AHQdDQBLQBBI+44HQUAMoAKACgAoAKACgAoAsRtuX3FADZvuj60AMh+/QBPQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEE336AHQdDQAsr4G0daAIaACgAoAKACgAoAKACgB0TbW9jQBJN90fWgBkP36AJ6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAgm+/QA6DoaAHlFJyRQAeWvpQAeWvpQAeWvpQAeWvpQAeWvpQAeWvpQAeWvpQAeWvpQAeWvpQA2b7g+tADIfv0AT0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBBN9+gBEcp0FADvOPoKADzj6CgA84+goAPOPoKADzj6CgA84+goAPOPoKADzj6CgA84+goAPOPoKAGu5YYIoAWH79AE9ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAQSg7+lADMH0NABg+hoAMH0NABg+hoAMH0NABg+hoAMH0NABg+hoAMH0NABg+hoAMH0NABg+hoAfEDv6UAT0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAASAMmgBAwPQ9KADcOOevSgBSQOtAATgZoATcAASetACkgDJoAAcjNACAg9DQAEgdTQABgRkGgBA6k4zQAoIJxnkUALkZx3oAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAZJ0B7A80ALkFSRQAwjKIKAFzuVfXPNAD3+6fpQBG4yiCgBXO5FHrQAoOIs+1ACR/K2PUZoAVQGZie3FAC/Lg4x07UANRlwBxmgBDxIW7ZwaAHL/rG/CgB9ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIWC9TQAwY3MV6YoAB92OgAYYkHoTQA9/un6UAMHWP6UAIo5I7DigA6xqvrQApXaynJPbmgABCMQ3Q80AAxufb0xQAIy7QMjNACgZZwaAEizuYHqOKAJKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoACAetABgAYoAMUAFABQAYoAKADA9KACgAIz1oAMAUAJgegoAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA/wD/2Q=='
      //if(size != null) path = path.replace('products/', 'products3/')
      //path = path.replace('.png', '')
      return `https://static3.ticketapp.cl/${path}`
    },
    formatNumber: (num = 0) => {
      if (!num) return 0

      if (num.toString().indexOf('.') != -1) {
        let decimal = num.toString()[num.toString().indexOf('.') + 1]
        if (decimal > 5) num = num + 1
      }
      let result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      if (result.indexOf('.') > -1)
        result = result.substring(0, result.indexOf('.'))
      return result
    },
  }
}
)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
